import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { hasOptionalPropertyOfType } from "@ciaopeople/cp-shatsu/CustomTypes";
import { inEnum, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection";

/**
 * rappresenta la tipologia di dispositivo / software 
 * associato ad un Registration ID (sottoscrizione)
 */
export enum NotificationDeviceType {
    ANDROID = 'A',
    IOS = 'I',
    SAFARI_MAC = 'SM',
    GENERIC_WEBPUSH_BROWSER = 'B',
    CHROME_BROWSER = 'C',
    FIREFOX_BROWSER = 'F',
    EDGE_BROWSER = 'E',
    UNSPECIFIED = 'U'
}

export enum NotificationSystemType {
    GCM = "GCM",
    APNS = "APNS",
    WebPushVAPID = "WebPushBrowserEndpoint",
    SafariWebPushAPNS = "SafariWebPushAPNS",
    Firebase = "Firebase"
}


type SubscriptionToken = string;

/**
 * oggetto base utilizzato per rappresentare un dispositivo di notifica nelle richieste di eliminazione/aggiunta
 */
interface BaseDeviceReqObj {
    device_id?: string
}

export function isBaseDeviceReqObj(obj: any): obj is BaseDeviceReqObj {
    return isObject(obj) && 
        hasOptionalPropertyOfType(obj, "device_id", isString);
}


/**
 * rappresentazione di un endpoint webpush (non gestito via FCM)
 */
export interface WebPushReqObj extends BaseDeviceReqObj {
    webpush_endpoint: string
}

export function isWebPushReqObj(obj: any): obj is WebPushReqObj {
    return isObject(obj) && isString(obj.webpush_endpoint);
}

/**
 * rappresentazione di un token FCM
 */
export interface FCMReqObj extends BaseDeviceReqObj {
    token: string,
    device_name?: string,
    device_type: NotificationDeviceType
}

export function isFCMReqObj(obj: any): obj is FCMReqObj {
    return isObject(obj) && 
            isString(obj.token) && 
            hasOptionalPropertyOfType(obj, "device_name", isString) &&
            inEnum(obj.device_type, NotificationDeviceType);
}


export interface FirebaseDeviceRequestPayload {
    firebase: FCMReqObj
}

export function isFirebaseDeviceRequestPayload(obj: any): obj is FirebaseDeviceRequestPayload {
    return isObject(obj) && hasOwnProperty(obj, "firebase") && isFCMReqObj(obj.firebase);
}

export interface WebpushDeviceRequestPayload {
    webPush: WebPushReqObj
}

export function isWebpushDeviceRequestPayload(obj: any): obj is WebpushDeviceRequestPayload {
    return isObject(obj) && hasOwnProperty(obj, "webPush") && isWebPushReqObj(obj.webPush);
}

/**
 * payload delle richieste di aggiunta / eliminazione
 */
export type  DeviceUpdateRequestPayload = FirebaseDeviceRequestPayload | WebpushDeviceRequestPayload;

export function isDeviceUpdateRequestPayload(obj: any): obj is DeviceUpdateRequestPayload {
    return isFirebaseDeviceRequestPayload(obj) || isWebpushDeviceRequestPayload(obj);
}

export interface SubscriptionIdentifier {
    notificationSystemType: NotificationSystemType,
    token: SubscriptionToken
}

export type DeviceOrientedRequest = SubscriptionIdentifier;

export interface DeviceSubscription extends SubscriptionIdentifier {
   
    deviceId: string,
    applicationId?: string,
    deviceType: NotificationDeviceType,
    deviceName?: string,
    enabled: boolean

}

export interface SubscriptionListResponse {
    id: string,
    subscriptions: DeviceSubscription[]
}

export function getNotificationDeviceTypeFromDetectedWebview(webview: DetectedWebView): NotificationDeviceType {
    
    if(webview.native_app) {
        if(webview.platform.ios) return NotificationDeviceType.IOS;
        else return NotificationDeviceType.ANDROID;
    }
    else if(webview.browser.chrome) return NotificationDeviceType.CHROME_BROWSER;
    else if (webview.browser.safari) {
        if(!webview.device.phone && !webview.device.tablet) 
            return NotificationDeviceType.SAFARI_MAC;
        else NotificationDeviceType.GENERIC_WEBPUSH_BROWSER;
    }
    else if(webview.browser.edge) return NotificationDeviceType.EDGE_BROWSER;
    else if (webview.browser.firefox) return NotificationDeviceType.FIREFOX_BROWSER;
    else {
        return NotificationDeviceType.GENERIC_WEBPUSH_BROWSER;
    }
    
}


export function getDeviceNameFromDetectedWebview(webview: DetectedWebView): string {
    if(webview.browser)  {
        if(webview.browser.native_app) {
            if(webview.platform.ios) {
                return "iOS App Nativa";
            }
            else return "Android App Nativa";
        }
        else {
            let browserString = "Browser";
            let deviceString = "";
            let osString = "";
            if(webview.browser.chrome) browserString = "Chrome";
            else if(webview.browser.firefox) browserString = "Firefox";
            else if(webview.browser.safari) browserString = "Safari";
            else if(webview.browser.edge) browserString = "Edge";
            if(webview.device.phone) deviceString = "Phone";
            else if(webview.device.tablet) deviceString = "Tablet";
            if(webview.platform.android) osString = "Android";
            else if(webview.platform.ios) osString = "iOS";
            else if(webview.platform.linux) osString = "Linux";
            else if(webview.platform.windows) osString = "Windows";
            else if(webview.platform.macosx) osString = "MacOS";

            return `${osString?osString + " ":""}${deviceString?deviceString + " ":""}${browserString}`;
        }
    }
}
